import { section } from "@/glow";
import { animateDiscountCodeBar, shouldAnimate } from "@/lib/animation";

const selectors = {
  clipboardCopyButton: "[js-clipboard-copy-button]",
  clipboardCopyText: "[js-clipboard-copy-text]",
};

const attrs = {
  copySuccess: "data-copy-success",
  disabled: "disabled",
};

const properties = {
  preCopyWidth: "--pre-copy-width",
  preCopyHeight: "--pre-copy-height",
};

section("discount-code-bar", {
  onLoad() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };

    this.clipboardCopyButton = this.container.querySelector(
      selectors.clipboardCopyButton
    );

    this.clipboardCopyButton?.addEventListener(
      "click",
      e => this.handleClipboardCopyButtonClick(e),
      this.eventOptions
    );

    if (shouldAnimate(this.container)) {
      this.animateDiscountCodeBar = animateDiscountCodeBar(this.container);
    }
  },

  /**
   * Handles when the clipboard copy button is clicked.
   * @returns {void}
   */
  handleClipboardCopyButtonClick() {
    this.lockClipboardCopyButton();

    const clipboardCopyText = this.container.querySelector(
      selectors.clipboardCopyText
    );

    navigator.clipboard.writeText(clipboardCopyText.textContent.trim()).then(
      () => this.clipboardCopyButton.setAttribute(attrs.copySuccess, true),
      error => console.error(error)
    );

    setTimeout(() => {
      this.clipboardCopyButton.setAttribute(attrs.copySuccess, false);
      this.unlockClipboardCopyButton();
    }, 1500);
  },

  /**
   * Locks the clipboard copy button to prevent spamming.
   * This includes keeping the button's current width and height in place.
   * @returns {void}
   */
  lockClipboardCopyButton() {
    const preCopyWidth = this.clipboardCopyButton.offsetWidth;
    const preCopyHeight = this.clipboardCopyButton.offsetHeight;

    this.clipboardCopyButton.style.setProperty(
      properties.preCopyWidth,
      `${preCopyWidth}px`
    );
    this.clipboardCopyButton.style.setProperty(
      properties.preCopyHeight,
      `${preCopyHeight}px`
    );
    this.clipboardCopyButton.toggleAttribute(attrs.disabled, true);
  },

  /**
   * Unlocks the clipboard copy button, allowing button to resize again.
   * @returns {void}
   */
  unlockClipboardCopyButton() {
    this.clipboardCopyButton.toggleAttribute(attrs.disabled, false);
    this.clipboardCopyButton.style.removeProperty(properties.preCopyWidth);
    this.clipboardCopyButton.style.removeProperty(properties.preCopyHeight);
  },

  onUnload() {
    this.eventController.abort();
    this.animateDiscountCodeBar?.destroy();
  },
});
